import { Component, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { FormBuilder } from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import SwalAlert from 'src/app/utils/swalalert';
import { HotelbookingsService } from 'src/app/api/hotelbooking/hotelbookings.service';
import { constants } from 'src/app/constants';
declare var $: any;

@Component({
  selector: 'app-hotelbookings-detail',
  templateUrl: './hotelbookings-detail.component.html',
  styleUrls: ['./hotelbookings-detail.component.css']
})
export class HotelbookingsDetailComponent {
  ngModalComponent: any;

  branchofficeSlug: string = '';
  checkId: number;
  book: any = null;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;


  bedroomSelected: any = null;
  typeRateObj: any = constants.HOTEL.TYPE_RATES[0];

  // array detail booking
  detail_bedrooms: any = [];
  detail_guests: any = [];
  detail_transfers: any = [];
  detail_sales: any = [];

  // totales
  total: any = 0;
  total_bedrooms: any = 0;
  total_sales: any = 0;

  total_pax: any = 0;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private globalService: GlobalService,
    private hotelbookingService: HotelbookingsService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.isEdit = true;
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    if (this.isEdit) {
      this.editData();
    }
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  editData(check_id = null) {
    this.hotelbookingService.get(this.checkId).subscribe({
      next: (data: any) => {
        console.log(data);
        this.book = data.data;
        //  ==================
        this.detail_bedrooms = this.book.blockbedrooms;
        this.detail_guests = this.book.guests;
        this.detail_transfers = this.book.detail_transfers;
        this.detail_sales = this.book.sales;

        setTimeout(() => {
          this.calculateTotal();
        }, 50);
        // this.company = this.globalService.getCompany();
        // this.book = result.book;
        // this.tours = result.tours;
        // this.hotels = result.hotels;
        // this.movements = result.movements;
        // this.commissions = result.commissions;

        // // agregar sucursales a la compania
        // this.company.branchoffices = result.branchoffices;
      }
    });
  }

  calculateTotal() {
    this.total = 0;
    this.total_bedrooms = 0;
    this.total_pax = 0;

    // calcular total de habitaciones
    for (let i in this.detail_bedrooms) {
      let item_ = this.detail_bedrooms[i];
      for (let j in item_.bedroom_selecteds) {
        let bedroom_ = item_.bedroom_selecteds[j];

        // sum total pax:
        this.total_pax = this.total_pax + Number(bedroom_.roomtype.capacity);

        let total_charges = 0;
        if (bedroom_.detail_charges.length > 0) {
          for (let c in bedroom_.detail_charges) {
            let charge = bedroom_.detail_charges[c];
            total_charges =
              total_charges +
              Number(charge.total) * Number(bedroom_.number_nights);
            if (charge.is_additional_pax) {
              this.total_pax = this.total_pax + Number(charge.quantity);
            }
          }
        }

        let past_subtotal = 0;
        for (let c in bedroom_.daily_rates) {
          past_subtotal = past_subtotal + Number(bedroom_.daily_rates[c].rate);
        }
        this.detail_bedrooms[i].bedroom_selecteds[j].subtotal = past_subtotal;

        let summary_total = total_charges + Number(bedroom_.subtotal);
        this.detail_bedrooms[i].bedroom_selecteds[j].subtotal = summary_total;
        this.total_bedrooms = this.total_bedrooms + Number(summary_total);
      }
    }

    // calcular total de consumos | ventas
    for(let i in this.detail_sales){
      let item_ = this.detail_sales[i];
      this.total_sales = this.total_sales + Number(item_.total);
    }

    // calcular total reserva
    this.total = this.total_sales + this.total_bedrooms;



  }




  detailRateBedroom(index_core: number, index: any) {
    this.bedroomSelected = this.detail_bedrooms[index_core].bedroom_selecteds[
      index
    ];
  }

  removedetailRateBedroom() {
    (<any>$('#modalNights')).modal('hide');
    this.bedroomSelected = null;
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservashotel/reservas/editar',
      id
    ]);
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/reservashotel/reservas/lista'
    ]);
  }
}
